window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    // Admin pages load jQuery/Bootstrap from Backpack scripts first; do not replace them.
    if (!window.jQuery) {
        window.Popper = require('popper.js').default;
        window.$ = window.jQuery = require('jquery');
        require('bootstrap');
    } else if (!window.Popper) {
        window.Popper = require('popper.js').default;
    }

    // Keep a hard reference so it can be re-exposed on window even if another
    // script later calls jQuery.noConflict(true) (e.g. laravel-debugbar does
    // this on every page render, which would otherwise wipe `window.jQuery`
    // and break jQuery plugins loaded via standalone <script> tags after us,
    // such as bootstrap-multiselect).
    window.__bundleJquery = window.jQuery;
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

const csrfToken = document.head.querySelector('meta[name="csrf-token"]');

function applyCsrfToken() {
    if (!csrfToken) {
        console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
        return;
    }

    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken.content;

    // Backpack admin and DataTables use jQuery.ajax, not axios.
    // Re-apply on DOMContentLoaded because Backpack may load another jQuery after this bundle.
    const $ = window.jQuery || window.__bundleJquery;
    if ($) {
        $.ajaxSetup({
            headers: { 'X-CSRF-TOKEN': csrfToken.content },
        });
    }
}

applyCsrfToken();
document.addEventListener('DOMContentLoaded', applyCsrfToken);

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });
``
